import React, { useContext, createContext } from 'react';
import useOrderStore, { Methods } from '../../../commons/hooks/useOrderStore';
import { OrderStore } from '../../../commons/order-store/order-store';

export const ConfirmationContextStore = createContext({} as OrderStore);
export const ConfirmationContextDispatch = createContext({} as Methods);

export const useConfirmationStore = () => {
  const store = useContext(ConfirmationContextStore);

  if (!store) {
    throw new Error('There is no delivery provider');
  }

  return store;
};

export const useConfirmationDispatch = () => {
  const methods = useContext(ConfirmationContextDispatch);

  if (!methods) {
    throw new Error('There is no delivery provider');
  }

  return methods;
};

interface ConfirmationContextProviderProps {
  adId: string;
  orderId: string;
  children: React.ReactNode;
}

export const ConfirmationContextProvider = ({
  adId,
  orderId,
  children,
}: ConfirmationContextProviderProps) => {
  const { state, ...methods } = useOrderStore(adId, orderId);

  return (
    <ConfirmationContextDispatch.Provider value={methods}>
      <ConfirmationContextStore.Provider value={state}>
        {children}
      </ConfirmationContextStore.Provider>
    </ConfirmationContextDispatch.Provider>
  );
};
